import { render, staticRenderFns } from "./LocaleFieldButton.vue?vue&type=template&id=4cda22fc"
import script from "./LocaleFieldButton.vue?vue&type=script&lang=js"
export * from "./LocaleFieldButton.vue?vue&type=script&lang=js"
import style0 from "./LocaleFieldButton.vue?vue&type=style&index=0&id=4cda22fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports